import { FormSelectOption } from "../formSelectOption.types";
/**
 * All systems for tax
 */

export const IncomeCategories: FormSelectOption[] = [
    { id: "", name:"" },
    { id: "ASSOC", name: "ASSOC" },
    { id: "BA", name: "BA" },
    { id: "BIC", name: "BIC" },
    { id: "BNC", name: "BNC" },
    { id: "RF", name: "RF" },
];

export const TaxRegimes: FormSelectOption[] = [
    { id: "", name:"" },
    { id: "OTHER", name: "Autre" },
    { id: "SELF_EMPLOYED", name: "Auto-entrepreneur" },
    { id: "CONTROLLED_DECLARATION", name: "Déclaration contrôlée" },
    { id: "MICRO_BA", name: "Micro BA" },
    { id: "MICRO_ENTERPRISE", name: "Micro entreprise" },
    { id: "REAL_SIMPLIFIED", name: "Réel simplifié" },
    { id: "REAL_NORMAL", name: "Réel normal" },
];

export const TaxSystemsTypes: FormSelectOption[] = [
    { id: "IS", name: "Impôts sur les Sociétés" },
    { id: "IR", name: "Impôts sur les Revenus" },
] as const;

export const filteredTaxRegimeByIncomeCategory: Record<string, string[]> = {
    "ASSOC": [ "OTHER", "REAL_SIMPLIFIED", "REAL_NORMAL"],
    "BA": [ "MICRO_BA", "REAL_SIMPLIFIED", "REAL_NORMAL"],
    "BIC": [ "MICRO_ENTERPRISE", "REAL_SIMPLIFIED", "REAL_NORMAL"],
    "BNC": [ "CONTROLLED_DECLARATION", "MICRO_ENTERPRISE", "SELF_EMPLOYED"],
    "RF": [ "OTHER"]
};

export const filteredIncomeCategoryByTaxRegime: Record<string, string[]> = {
    "OTHER": [ "ASSOC", "RF"],
    "SELF_EMPLOYED": [ "BNC"],
    "CONTROLLED_DECLARATION": [ "BNC"],
    "MICRO_BA": [ "BA"],
    "MICRO_ENTERPRISE": [ "BIC", "BNC"],
    "REAL_SIMPLIFIED": [ "ASSOC", "BA", "BIC"],
    "REAL_NORMAL": [ "ASSOC", "BA", "BIC"],
};